{
  "ordersInfo": {
    "pcs": "pcs.",
    "side": {
      "buy": "Buy",
      "sell": "Sell",
      "sell_short": "Sell Short"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    }
  }
}
